import OlFeature from 'ol/Feature'

import {Geometry} from './Geometry'

import OlGeometry from 'ol/geom/Geometry'
import {v4 as uuidv4} from 'uuid'
import {AttachmentInfos} from '../../interfaces/models'

export enum FeatureStatus {
  New = 'New', //created localy, still not saved on the server =
  Unchanged = 'Unchanged', // same as the server version
  Deleted = 'Deleted', //deleted localy, still not saved on the server
  Modified = 'Modified' // modified localy but not on the server
}

interface FeatureValues {
  _SETTLEMENT: {
    values_: {
      EKATTE: string
    }
  }
}

export class Feature extends OlFeature<OlGeometry> {
  public guid: string
  public status: FeatureStatus
  public localDbStatus: FeatureStatus
  constructor(opts?: any) {
    super(opts)
    this.guid = uuidv4()
    this.status = FeatureStatus.Unchanged
    this.localDbStatus = FeatureStatus.Unchanged
    this.attachmentChanges = {
      adds: {},
      updates: {},
      deletes: {}
    }
    this.attachments = {}
  }
  attachments: AttachmentInfos
  attachmentChanges: {
    adds: AttachmentInfos
    updates: AttachmentInfos
    deletes: AttachmentInfos
  }
  getGeometry(): Geometry {
    return super.getGeometry() as Geometry
  }
  setGeometry(geometry?: OlGeometry) {
    super.setGeometry(geometry!)
  }
  getId(): any {
    if (this.status == FeatureStatus.New || !super.getId()) return this.guid
    return super.getId()
  }
  clone(): any {
    const clone = new Feature(this.getProperties())
    clone.setId(super.getId())
    clone.guid = this.guid
    clone.status = this.status
    clone.localDbStatus = this.localDbStatus
    clone.setGeometryName(this.getGeometryName())
    const geometry = this.getGeometry()
    if (geometry) {
      clone.setGeometry(geometry.clone())
    }
    const style = this.getStyle()
    if (style) {
      clone.setStyle(style)
    }
    clone.attachments = {}
    for (const att in this.attachments) {
      clone.attachments[att] = this.attachments[att]
    }
    clone.attachmentChanges = {
      adds: {},
      updates: {},
      deletes: {}
    }
    for (const att in this.attachmentChanges.adds) {
      clone.attachmentChanges.adds[att] = {...this.attachmentChanges.adds[att]}
    }
    for (const att in this.attachmentChanges.updates) {
      clone.attachmentChanges.updates[att] = {...this.attachmentChanges.updates[att]}
    }
    for (const att in this.attachmentChanges.deletes) {
      clone.attachmentChanges.deletes[att] = {...this.attachmentChanges.deletes[att]}
    }
    return clone
  }
}
